"use client";
import { useCallback, useMemo, useState } from "react";
import Modal from "../../theme/components/Modal";
import ProductCuttingForm from "../components/ProductCuttingForm";

const useProductCuttingModal = ({ cutting, cuttingRange, onCuttingChange }) => {
  const [modalVisible, setModalVisible] = useState(null);
  const hideProductCuttingModal = useCallback(() => setModalVisible(false), []);
  const openProductCuttingModal = useCallback(() => setModalVisible(true), []);

  const ProductCuttingModal = useMemo(
    () =>
      modalVisible ? (
        <Modal
          open={modalVisible}
          wide
          onClose={hideProductCuttingModal}
          title="Zuschnitt anpassen"
        >
          <ProductCuttingForm
            min={cuttingRange?.[0]}
            max={cuttingRange?.[1]}
            {...cutting}
            onCuttingChange={(newCutting) => {
              if (newCutting !== undefined) {
                onCuttingChange?.(newCutting);
              }
              hideProductCuttingModal();
            }}
          />
        </Modal>
      ) : null,
    [
      modalVisible,
      hideProductCuttingModal,
      cutting,
      cuttingRange,
      onCuttingChange,
    ],
  );

  return {
    openProductCuttingModal,
    ProductCuttingModal,
  };
};

export default useProductCuttingModal;
